// src/api/uploadApi.ts
import axios from "axios";

export interface UploadResponse {
  url: string;
}

export const uploadApi = {
  upload: async (file: File): Promise<string> => {
    // 1) read file as base64 Data URL
    const dataUrl = await new Promise<string>((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result as string);
      r.onerror = () => reject(new Error("Failed to read file"));
      r.readAsDataURL(file);
    });

    // 2) generate a unique filename
    const filename = `${Date.now()}-${file.name}`;

    // 3) POST to your Next.js API route (on same origin)
    const resp = await axios.post<UploadResponse>(
      "/api/upload",
      { dataUrl, filename },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return resp.data.url;
  },
};
